import { observable, action } from 'mobx'
import { TransferStatus } from '@getgreenline/homi-shared'
import { PaginationUtil } from '../../../../../utilities/pagination'
import { History } from 'history'

interface ITransferPagination {
  statusFilter: TransferStatus | undefined
  fromLocationIdFilter: number | undefined
  toLocationIdFilter: number | undefined
  titleFilter: string
}

export class TransferPagination extends PaginationUtil {
  @observable
  transferPaginationFilter: ITransferPagination = {
    statusFilter: undefined,
    fromLocationIdFilter: undefined,
    toLocationIdFilter: undefined,
    titleFilter: '',
  }

  constructor(history: History) {
    super(history, false)

    const { titleFilter, statusFilter, fromLocationIdFilter, toLocationIdFilter } =
      history.getCurrentLocation().query

    if (titleFilter) {
      this.transferPaginationFilter.titleFilter = titleFilter
    }
    if (statusFilter) {
      this.transferPaginationFilter.statusFilter = statusFilter
    }
    if (fromLocationIdFilter) {
      this.transferPaginationFilter.fromLocationIdFilter = fromLocationIdFilter
    }
    if (toLocationIdFilter) {
      this.transferPaginationFilter.toLocationIdFilter = toLocationIdFilter
    }

    this.applyFilters()
  }

  @action
  setStatusFilter(statusFilter: TransferStatus | undefined) {
    this.transferPaginationFilter.statusFilter = statusFilter
  }

  @action
  setTitleFilter(titleFilter: string) {
    this.transferPaginationFilter.titleFilter = titleFilter
  }

  @action
  setFromLocationIdFilter(fromLocationIdFilter: number | undefined) {
    this.transferPaginationFilter.fromLocationIdFilter = fromLocationIdFilter
  }

  @action
  setToLocationIdFilter(toLocationIdFilter: number | undefined) {
    this.transferPaginationFilter.toLocationIdFilter = toLocationIdFilter
  }

  applyFilters() {
    this.apply(this.transferPaginationFilter)
  }

  getFilters() {
    return {
      ...this.transferPaginationFilter,
      ...this.paginationFilter,
    }
  }
}
